<template>
<div class="absolute left-0">
  <p class="text-black my-2 ml-10 mr-28 font-bold">
    <slot></slot>
  </p>
</div>
</template>

<script>
export default {
  name: 'LabelStep'
}
</script>

<style lang="scss" scoped>

</style>
